// 回到顶部方法
export default function () {
  let distance = document.documentElement.scrollTop || document.body.scrollTop // 获得当前高度
  let step = distance / 50 // 每步的距离
  var jump = function () {
    if (distance > 0) {
      distance -= step
      window.scrollTo(0, distance)
      setTimeout(jump, 6)
    }
  }
  jump()
}



// WEBPACK FOOTER //
// ./src/utils/goTop.js